import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import DrugListForm from './DrugListForm';

const DrugListModal = ({ show, onHide, druglistvalue, edittrigger, onCallParent }) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title as="h5">
                    {druglistvalue ? 'Edit Drug' : 'Add Drug'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-body-tertiary p-4">
                <DrugListForm
                    edittrigger={edittrigger}
                    onCallParent={() => {
                        if (onCallParent) onCallParent();
                        onHide();
                    }}
                    druglistvalue={druglistvalue}
                />
            </Modal.Body>
        </Modal>
    );
};

DrugListModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    druglistvalue: PropTypes.any,
    edittrigger: PropTypes.number,
    onCallParent: PropTypes.func
};

export default DrugListModal;

